import { render, staticRenderFns } from "./ViewInvoiceView.vue?vue&type=template&id=920c5f86&"
import script from "./ViewInvoiceView.vue?vue&type=script&lang=js&"
export * from "./ViewInvoiceView.vue?vue&type=script&lang=js&"
import style0 from "./ViewInvoiceView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports